<template>
  <section>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-4"></div>
          <div class="col-md-4">
            <a @click.prevent="reloadSync" href="#" class="btn btn-primary btn-block m-btn m-btn--icon">
              <span>
                <i class="flaticon-tool"></i>
                <span>{{ 'reboot_sync' | translate | capitalize }}</span>
              </span>
            </a>
          </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="resetForm" id="btn-cancel">
        {{ 'close' | translate | capitalize }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  methods: {
    ...mapActions(['rebootSync', 'setStatusSyncModal']),
    resetForm () {
      window.$('#sync_modal').modal('hide')
      this.setStatusSyncModal(false)
    },
    reloadSync () {
      this.$spinner.show()
      this.rebootSync()
        .then(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('reboot_sync_ok', 1)
        })
        .catch(() => {
          this.$spinner.remove()
          this.resetForm()
          this.$toast('reboot_sync_fail', 4)
        })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Sync.vue